import { useMemo } from 'react';
import { getDiceFaceDataUrl } from './diceFaceUtils';

interface DiceFaceProps {
  value: number;
  size?: number;
}

export function DiceFace({ value, size = 28 }: DiceFaceProps) {
  const src = useMemo(() => getDiceFaceDataUrl(value), [value]);

  return (
    <img
      src={src}
      alt={`주사위 ${value}`}
      className="dice-face rounded-md shadow-sm"
      width={size}
      height={size}
      draggable={false}
    />
  );
}
